export const Page_Size_Options = [5, 10, 20, 50, 100];